<article class="mt-1">
  @if (dataTable()) {
    <div class="content-container">
      @if (gateways().length) {
        <div class="search">
          <app-search-input [resultCount]="filteredCount" [searchText]="filtereText" (onSearchChanged)="searchChanged($event)" tooltipText=""></app-search-input>
        </div>

        @if (isAdmin) {
          <app-toolbar>
            <div class="left"><i class="mdi mdi-shield-account-outline"></i> 4D Admin</div>
            <div class="right">
              <a href="https://grafana.4dml.com" target="_blank">Grafana <i class="mdi mdi-open-in-new"></i> </a>
            </div>
          </app-toolbar>
        }

        <div class="mt-1"></div>
        <app-data-table [dataTable]="dataTable()" dataTableKey="grafana:list" (onRowClick)="rowClick($event)" />
      } @else {
        No dashboards available.
      }
    </div>
  } @else {
    <app-please-wait />
  }

  <router-outlet></router-outlet>
</article>
